import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "4534 968.483 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4541.2 980.483h1.6v-4.8h-1.6zm.8-6.4a.77.77 0 0 0 .57-.23.77.77 0 0 0 .23-.57.77.77 0 0 0-.23-.57.77.77 0 0 0-.57-.23.77.77 0 0 0-.57.23.77.77 0 0 0-.23.57q0 .34.23.57t.57.23m0 10.4a7.8 7.8 0 0 1-3.12-.63 8.1 8.1 0 0 1-2.54-1.71 8.1 8.1 0 0 1-1.71-2.54 7.8 7.8 0 0 1-.63-3.12q0-1.659.63-3.12.63-1.46 1.71-2.54a8.1 8.1 0 0 1 2.54-1.71 7.8 7.8 0 0 1 3.12-.63q1.659 0 3.12.63 1.46.63 2.54 1.71t1.71 2.54q.63 1.461.63 3.12a7.8 7.8 0 0 1-.63 3.12q-.63 1.46-1.71 2.54a8.1 8.1 0 0 1-2.54 1.71 7.8 7.8 0 0 1-3.12.63m0-1.6q2.68 0 4.54-1.86t1.86-4.54-1.86-4.54-4.54-1.86-4.54 1.86-1.86 4.54 1.86 4.54 4.54 1.86m0-6.4",
      class: "fills",
      style: {"fill":"#1f7eff","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }